'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
    let model = this;
    $scope.global = Global;
    model.settings = settings;

    model.tableIdentifiers = { key: false, id: false };

    socketIo('/api/system_events/endpoint_by_user_and_type').then(function (socket) {
        /////////////
        /// TABLE ///
        /////////////
        // register data object
        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'table',
                socket: socket
            },
            grouping: ['event_type'],
            hideToggleBytes: true,
            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
            title: 'Local Endpoints Triggering Event',
            columns: [
                {
                    title: 'Last Seen',
                    select: 'time',
                    dView: true,
                    link: {
                        type: 'search',
                        table_name: 'events',
                        val: ['local_hostname', 'local_ip','event_type'],
                        crumb: false
                    }
                },
                { title: 'Events', select: 'count', dView: true },
                //{ title: 'Stealth', select: 'local_stealth', dView: true },
                { title: 'Local Hostname', select: 'local_hostname', dView: true },
                { title: 'Local User', select: 'local_user', dView: true },
                { title: 'Local IP', select: 'local_ip', dView: true },
                { title: 'Event Type', select: 'event_type', dView: true },
                { title: 'Event Details', select: 'event_detail', dView: true },
                { title: 'Event Source', select: 'event_src', dView: true },
                { title: 'Event ID', select: 'event_id', dView: true }
            ],
            searchCategories: {
                'count': 'Events',
                'local_stealth': 'Stealth',
                'local_hostname': 'Local Hostname',
                'local_user': 'Local User',
                'local_ip': 'Local IP',
                'event_type': 'Event Type',
                'event_detail': 'Event Details',
                'event_src': 'Event Source',
                'event_id': 'Event ID',
            }
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.tableIdentifiers = {
                id: result.id,
                key: result.key
            }
            // initalize table with column information so it can compile the directive
            $scope.$broadcast('table-build', model.tableIdentifiers);

            let time = angular.copy($scope.main.getTime());
            model.loadStart = time.end
            model.loadEnd = time.end
            // return promise to build dimensions and groups for table
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {
            model.complete = true;
            // stop the table spinner as soon as the resolve comes in
            usSpinnerService.stop(model.tableIdentifiers.id);
        }, function (err) {

        }, function (result) {
            // add rows
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                // with our first data return, we can build dimensions and groups for our data
                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
                    // dont start the spinner if the table loads faster than building group dim
                    if (!model.complete) {
                        // start table spinner right before init, but after build
                        usSpinnerService.spin(model.tableIdentifiers.id);
                    }
                    // initalize rows
                    $scope.$broadcast('init', model.tableIdentifiers);
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                }, function (err) {
                    console.log('error')
                    console.log(err)
                })
            } else {
                if (result.min) {
                    model.loadStart = result.min;
                }
                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
            }
        })
        $scope.$on('$destroy', function () {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/system_events/endpoint_by_user_and_type.js
 **/